const STORAGE_KEY = 'gentoo-lead-form-attempt';
let currentAttempt;

export const getLeadFormAttemptId = (partnerId, chatUserId, scenarioKey) => {
    const scope = JSON.stringify([partnerId, chatUserId, scenarioKey || null]);
    try {
        const stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY));
        if (stored?.scope === scope && /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(stored.id)) {
            currentAttempt = stored;
            return stored.id;
        }
    } catch (_) { /* Retain the in-memory attempt when storage is unavailable. */ }
    if (currentAttempt?.scope !== scope) {
        const bytes = crypto.getRandomValues(new Uint8Array(16));
        bytes[6] = (bytes[6] & 15) | 64;
        bytes[8] = (bytes[8] & 63) | 128;
        const hex = Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');
        const id = `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
        currentAttempt = { scope, id };
    }
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(currentAttempt)); } catch (_) { /* Best effort. */ }
    return currentAttempt.id;
};

export const clearLeadFormAttempt = () => {
    currentAttempt = undefined;
    try { sessionStorage.removeItem(STORAGE_KEY); } catch (_) { /* Best effort. */ }
};
